import { useRef as H, useEffect as x, useState as V, useCallback as W, useContext as Ae, useMemo as ae, createContext as xe } from "react";
import { usePortalRef as Me, useId as Ce, useSafeLayoutEffect as M, useLiveRef as de, useBooleanEvent as R, useWrapElement as B, useForkRef as le, useForceUpdate as Te, useEvent as Y } from "../../../ariakit-react-utils/esm/hooks.js";
import { createComponent as Fe, createElement as Le, createHook as Ne } from "../../../ariakit-react-utils/esm/system.js";
import { getActiveElement as q, contains as D, isButton as He, getDocument as P, getWindow as Re, closest as Be } from "../../../ariakit-utils/esm/dom.js";
import { addGlobalEventListener as j, queueBeforeEvent as ke, isSelfTarget as se } from "../../../ariakit-utils/esm/events.js";
import { getFirstTabbableIn as $e, isFocusable as fe, focusIfNeeded as We } from "../../../ariakit-utils/esm/focus.js";
import { chain as pe, noop as me } from "../../../ariakit-utils/esm/misc.js";
import { isApple as Ve, isMac as qe, isSafari as ge } from "../../../ariakit-utils/esm/platform.js";
import { useDisclosureContent as he } from "../disclosure/disclosure-content.js";
import { useFocusTrapRegion as Ke } from "../focus-trap/focus-trap-region.js";
import { useFocusable as Xe } from "../focusable/focusable.js";
import { HeadingLevel as Ye } from "../heading/heading-level.js";
import { usePortal as je } from "../portal/portal.js";
import { jsx as F } from "react/jsx-runtime";
import { D as ze, a as Ue, b as Ge } from "../dialog-context-a736b58f.js";
import { flushSync as Je } from "react-dom";
function be(t) {
  const e = H();
  return x(() => {
    if (!t) {
      e.current = null;
      return;
    }
    return j("mousedown", (r) => {
      e.current = r.target;
    }, !0);
  }, [t]), e;
}
function Qe(t) {
  var C;
  let {
    state: e,
    backdrop: n,
    backdropProps: r,
    hideOnInteractOutside: o = !0,
    hideOnEscape: i = !0,
    hidden: d,
    children: g
  } = t;
  const l = H(null);
  e = ae(() => ({
    ...e,
    // Override the setContentElement method to prevent the backdrop from
    // overwriting the dialog's content element.
    setContentElement: me
  }), [e]), M(() => {
    const p = l.current, T = e.contentElement;
    p && T && (p.style.zIndex = getComputedStyle(T).zIndex);
  }, [e.contentElement]);
  const c = r == null ? void 0 : r.onClick, f = R(o), v = be(e.mounted), E = Y((p) => {
    c == null || c(p), !p.defaultPrevented && se(p) && v.current === p.currentTarget && f(p) && (p.stopPropagation(), e.hide());
  }), a = r == null ? void 0 : r.onKeyDown, s = R(i), h = Y((p) => {
    a == null || a(p), !p.defaultPrevented && p.key === "Escape" && se(p) && s(p) && e.hide();
  }), b = he({
    state: e,
    id: void 0,
    role: "presentation",
    tabIndex: -1,
    hidden: d,
    ...r,
    ref: le(r == null ? void 0 : r.ref, l),
    onClick: E,
    onKeyDown: h,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...r == null ? void 0 : r.style
    }
  });
  return /* @__PURE__ */ F(typeof n != "boolean" && n || "div", {
    ...b,
    "data-backdrop": (C = e.contentElement) == null ? void 0 : C.id,
    children: g
  });
}
const Ze = ["SCRIPT", "STYLE"];
function _e(t, e) {
  return Ze.includes(t.tagName) ? !1 : !e.some((n) => n && D(t, n));
}
function ye(t, e) {
  for (let n of t) {
    const r = P(n);
    for (; n != null && n.parentElement && n !== r.body; ) {
      for (const o of n.parentElement.children)
        _e(o, t) && e(o);
      n = n.parentElement;
    }
  }
}
function et(t) {
  const e = t.getAttribute("aria-hidden") || "";
  return t.setAttribute("aria-hidden", "true"), () => {
    e ? t.setAttribute("aria-hidden", e) : t.removeAttribute("aria-hidden");
  };
}
function ie() {
  const t = [];
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return ye(n, (i) => {
    t.unshift(et(i));
  }), () => {
    t.forEach((i) => i());
  };
}
function tt(t) {
  if (!("style" in t)) return me;
  const e = t.style.pointerEvents;
  return t.style.pointerEvents = "none", () => {
    t.style.pointerEvents = e ?? "";
  };
}
function rt() {
  const t = [];
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return ye(n, (i) => {
    t.unshift(tt(i));
  }), () => {
    t.forEach((i) => i());
  };
}
function nt(t, e) {
  const r = P(t).createElement("button");
  return r.type = "button", r.tabIndex = -1, r.textContent = "Dismiss popup", r.style.border = "0px", r.style.clip = "rect(0 0 0 0)", r.style.height = "1px", r.style.margin = "-1px", r.style.overflow = "hidden", r.style.padding = "0px", r.style.position = "absolute", r.style.whiteSpace = "nowrap", r.style.width = "1px", r.addEventListener("click", e), t.prepend(r), () => {
    r.removeEventListener("click", e), r.remove();
  };
}
function ve(t, e, n) {
  const [r, o] = Te(), i = W(() => {
    if (!n) return !1;
    const d = t.current;
    if (!d) return !1;
    const {
      body: g
    } = P(d), l = g.getAttribute(e);
    return !l || l === d.id;
  }, [r, n, e]);
  return M(() => {
    const d = t.current;
    if (!d || !n) return;
    const {
      body: g
    } = P(d);
    if (!i()) {
      const l = new MutationObserver(() => Je(o));
      return l.observe(g, {
        attributeFilter: [e]
      }), () => l.disconnect();
    }
    return g.setAttribute(e, d.id), () => {
      g.removeAttribute(e);
    };
  }, [r, t, n, i, e]), i;
}
function ot(t, e) {
  x(() => {
    if (!e.open) return;
    const n = t.current;
    if (!n) return;
    const r = new MutationObserver((o) => {
      let [i] = o;
      if (!i || i.target !== n) return;
      const d = P(n);
      q(n) === d.body && n.focus();
    });
    return r.observe(n, {
      childList: !0,
      subtree: !0
    }), () => r.disconnect();
  }, [e.open, t]);
}
function st(t) {
  return t.tagName === "HTML" ? !0 : D(P(t).body, t);
}
function it(t, e) {
  if (D(t, e)) return !0;
  const n = e.getAttribute("aria-activedescendant");
  if (n) {
    const r = P(t).getElementById(n);
    if (r)
      return D(t, r);
  }
  return !1;
}
function ut(t, e) {
  return !t || !e ? !1 : e.hasAttribute("data-backdrop") && e.getAttribute("data-backdrop") === t.id;
}
function ct(t) {
  return (e) => {
    const n = e.current;
    return n ? !!(D(n, t) || ut(n, t)) : !1;
  };
}
function k(t) {
  let {
    type: e,
    listener: n,
    dialogRef: r,
    nestedDialogs: o,
    disclosureRef: i,
    enabled: d,
    capture: g
  } = t;
  const l = Y(n), c = de(o);
  x(() => d ? j(e, (v) => {
    const E = r.current, a = i == null ? void 0 : i.current, s = v.target;
    E && s && st(s) && (D(E, s) || a && it(a, s) || s.hasAttribute("data-focus-trap") || c.current.some(ct(s)) || l(v));
  }, g) : void 0, [d, r, i, l, g]);
}
function $(t, e) {
  return typeof t == "function" ? t(e) : !!t;
}
function at(t, e, n) {
  let {
    state: r,
    modal: o,
    hideOnInteractOutside: i,
    enabled: d = r.open
  } = n;
  const g = be(d), l = {
    disclosureRef: r.disclosureRef,
    enabled: d,
    dialogRef: t,
    nestedDialogs: e,
    capture: !0
  };
  k({
    ...l,
    type: "mousedown",
    listener: (c) => {
      const f = t.current;
      f && o && !$(i, c) && (f.focus(), c.preventDefault(), c.stopPropagation());
    }
  }), k({
    ...l,
    type: "click",
    listener: (c) => {
      const f = g.current;
      if (!f) return;
      if (!$(i, c)) {
        if (!o) return;
        c.preventDefault(), c.stopPropagation();
        return;
      }
      const v = t.current;
      v && D(v, f) || r.hide();
    }
  }), k({
    ...l,
    type: "focusin",
    listener: (c) => {
      const f = t.current;
      if (f) {
        if (!$(i, c)) {
          if (!o) return;
          f.focus(), c.preventDefault(), c.stopPropagation();
          return;
        }
        c.target !== P(f) && r.hide();
      }
    }
  }), k({
    ...l,
    type: "contextmenu",
    listener: (c) => {
      const f = t.current;
      if (f) {
        if (!$(i, c)) {
          if (!o) return;
          f.focus(), c.preventDefault(), c.stopPropagation();
          return;
        }
        r.hide();
      }
    }
  });
}
const ue = /* @__PURE__ */ xe({});
function dt(t, e) {
  let {
    state: n,
    modal: r
  } = e;
  const o = Ae(ue), [i, d] = V([]), [g, l] = V([]), c = W((a) => {
    var h;
    const s = (h = o.addDialog) == null ? void 0 : h.call(o, a);
    return l((b) => [...b, a]), () => {
      s == null || s(), l((b) => b.filter((A) => A !== a));
    };
  }, [o.addDialog]), f = W((a) => {
    var h;
    const s = (h = o.showModal) == null ? void 0 : h.call(o, a);
    return d((b) => [...b, a]), () => {
      s == null || s(), d((b) => b.filter((A) => A !== a));
    };
  }, [o.showModal]);
  M(() => {
    var a;
    return (a = o.addDialog) == null ? void 0 : a.call(o, t);
  }, [o.addDialog, t]), M(() => {
    var a;
    if (r && n.open)
      return (a = o.showModal) == null ? void 0 : a.call(o, t);
  }, [r, n.open, o.showModal, t]), M(() => {
    o.open === !1 && n.open && n.hide();
  }, [o.open, n.open, n.hide]);
  const v = ae(() => ({
    open: n.open,
    addDialog: c,
    showModal: f
  }), [n.open, c, f]), E = W((a) => /* @__PURE__ */ F(ue.Provider, {
    value: v,
    children: a
  }), [v]);
  return {
    nestedDialogs: g,
    openModals: i,
    wrapElement: E
  };
}
function ce(t, e) {
  if (!t) return () => {
  };
  const n = t.style.cssText;
  return Object.assign(t.style, e), () => {
    t.style.cssText = n;
  };
}
function lt(t, e, n) {
  if (!t) return () => {
  };
  const r = t.style.getPropertyValue(e);
  return t.style.setProperty(e, n), () => {
    r ? t.style.setProperty(e, r) : t.style.removeProperty(e);
  };
}
function ft(t) {
  const e = t.getBoundingClientRect().left;
  return Math.round(e) + t.scrollLeft ? "paddingLeft" : "paddingRight";
}
function pt(t, e) {
  const n = ve(t, "data-dialog-body-scroll", e);
  M(() => {
    const r = t.current;
    if (!r || !n()) return;
    const o = P(r), i = Re(r), {
      documentElement: d,
      body: g
    } = o, l = i.innerWidth - d.clientWidth, c = () => lt(d, "--scrollbar-width", `${l}px`), f = ft(d), v = () => ce(g, {
      overflow: "hidden",
      [f]: `${l}px`
    }), E = () => {
      const {
        scrollX: s,
        scrollY: h,
        visualViewport: b
      } = i, A = (b == null ? void 0 : b.offsetLeft) ?? 0, C = (b == null ? void 0 : b.offsetTop) ?? 0, p = ce(g, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(h - Math.floor(C))}px`,
        left: `${-(s - Math.floor(A))}px`,
        right: "0",
        [f]: `${l}px`
      });
      return () => {
        p(), process.env.NODE_ENV !== "test" && i.scrollTo(s, h);
      };
    }, a = Ve() && !qe();
    return pe(c(), a ? E() : v());
  }, [t, n]);
}
const mt = ge();
function gt(t, e) {
  const n = t.id;
  if (n)
    return e.getAttribute("data-backdrop") === n;
}
function Ee(t) {
  return (e) => e.current && D(e.current, t);
}
function ht(t, e) {
  const n = q();
  return !n || D(t, n) || gt(t, n) || e != null && e.some(Ee(n)) ? !1 : !!fe(n);
}
const bt = Ne((t) => {
  let {
    state: e,
    focusable: n = !0,
    modal: r = !0,
    portal: o = !!r,
    backdrop: i = !!r,
    backdropProps: d,
    hideOnEscape: g = !0,
    hideOnInteractOutside: l = !0,
    preventBodyScroll: c = !!r,
    autoFocusOnShow: f = !0,
    autoFocusOnHide: v = !0,
    initialFocusRef: E,
    finalFocusRef: a,
    ...s
  } = t;
  const h = H(null), b = H(e.open), {
    portalRef: A,
    portalNode: C,
    domReady: p
  } = Me(o, s.portalRef), T = s.preserveTabOrder && !r && e.mounted, L = e.open && !e.animating, K = r || o && T && ge(), De = Ce(s.id);
  M(() => {
    if (!L) return;
    const u = h.current, m = q(u, !0);
    m && m.tagName !== "BODY" && (u && D(u, m) || (e.disclosureRef.current = m));
  }, [L]);
  const Oe = dt(h, {
    state: e,
    modal: r
  }), {
    nestedDialogs: z,
    openModals: U,
    wrapElement: G
  } = Oe, X = de(z);
  pt(h, c && e.mounted), ot(h, e), at(h, z, {
    state: e,
    modal: r,
    hideOnInteractOutside: l,
    enabled: e.open
  }), mt && x(() => {
    if (!e.mounted) return;
    const u = e.disclosureRef.current;
    if (!u || !He(u)) return;
    const m = () => {
      let O = !1;
      const w = () => {
        O = !0;
      }, y = {
        capture: !0,
        once: !0
      };
      u.addEventListener("focusin", w, y), ke(u, "mouseup", () => {
        u.removeEventListener("focusin", w, !0), !O && We(u);
      });
    };
    return u.addEventListener("mousedown", m), () => {
      u.removeEventListener("mousedown", m);
    };
  }, [e.mounted, e.disclosureRef]), x(() => {
    if (!e.mounted || !p) return;
    const u = h.current;
    if (u && K)
      return u.querySelector("[data-dialog-dismiss]") ? void 0 : nt(u, e.hide);
  }, [e.mounted, p, K, e.hide]);
  const J = ve(h, "data-dialog-disable-outside", L && !U.length && K);
  M(() => {
    if (!J()) return;
    const u = o ? C : h.current;
    return r ? pe(
      ie(u),
      // When the backdrop is not visible, we also need to disable pointer
      // events outside of the modal dialog.
      i ? null : rt(u)
    ) : ie(u);
  }, [J, o, C, r, i]);
  const Q = H(), Z = !!f, _ = R(f);
  x(() => {
    var S;
    if (!L || !Z || !p || ((S = X.current) == null ? void 0 : S.some((I) => I.current && !I.current.hidden))) return;
    const m = e.contentElement;
    if (!(m != null && m.isConnected)) return;
    const O = E == null ? void 0 : E.current, w = O || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog
    // receives focus.
    $e(m, !0, o && T) || m, y = Q.current;
    if (Q.current = O, O === y) {
      const I = q(m, !0);
      if (I && D(m, I)) return;
    }
    _(w) && w.focus();
  }, [L, Z, p, e.contentElement, E, o, T, _]);
  const ee = !!v, te = R(v);
  x(() => {
    const u = h.current, m = b.current;
    if (b.current = e.open, !m || !ee || !u) return;
    const O = () => {
      const w = X.current;
      if (ht(u, w)) return;
      let y = (a == null ? void 0 : a.current) || e.disclosureRef.current;
      if (y) {
        if (y.id) {
          const S = P(y), I = `[aria-activedescendant="${y.id}"]`, N = S.querySelector(I);
          N && (y = N);
        }
        if (!fe(y)) {
          const S = Be(y, "[data-dialog]");
          if (S && S.id) {
            const I = P(S), N = `[aria-controls~="${S.id}"]`, oe = I.querySelector(N);
            oe && (y = oe);
          }
        }
        if (!te(y)) return;
        y.focus();
      }
    };
    return e.open ? O : O();
  }, [ee, e.open, a, e.disclosureRef, te]);
  const re = R(g);
  x(() => !p || !e.mounted ? void 0 : j("keydown", (m) => {
    const O = h.current;
    if (!O) return;
    const w = m.target, y = e.disclosureRef.current;
    if (m.key !== "Escape" || m.defaultPrevented || !w) return;
    (D(O, w) ? !X.current.some(Ee(w)) : !!(y && D(y, w))) && re(m) && e.hide();
  }), [p, e.mounted, e.disclosureRef, re, e.hide]), s = B(s, G, [G]), s = B(s, (u) => /* @__PURE__ */ F(Ye, {
    level: r ? 1 : void 0,
    children: u
  }), [r]), s = Ke({
    ...s,
    enabled: e.open && r && !U.length
  });
  const ne = s.hidden;
  s = B(s, (u) => i ? /* @__PURE__ */ F(Qe, {
    state: e,
    backdrop: i,
    backdropProps: d,
    hideOnInteractOutside: l,
    hideOnEscape: g,
    hidden: ne,
    children: u
  }) : u, [e, i, d, l, g, ne]);
  const [we, Pe] = V(), [Se, Ie] = V();
  return s = B(s, (u) => /* @__PURE__ */ F(ze.Provider, {
    value: e,
    children: /* @__PURE__ */ F(Ue.Provider, {
      value: Pe,
      children: /* @__PURE__ */ F(Ge.Provider, {
        value: Ie,
        children: u
      })
    })
  }), [e]), s = {
    id: De,
    "data-dialog": "",
    role: "dialog",
    tabIndex: n ? -1 : void 0,
    "aria-labelledby": we,
    "aria-describedby": Se,
    ...s,
    ref: le(h, s.ref)
  }, s = he({
    state: e,
    ...s
  }), s = Xe({
    ...s,
    focusable: n
  }), s = je({
    portal: o,
    ...s,
    portalRef: A,
    preserveTabOrder: T
  }), s;
}), yt = Fe((t) => {
  const e = bt(t);
  return Le("div", e);
});
process.env.NODE_ENV !== "production" && (yt.displayName = "Dialog");
export {
  yt as Dialog,
  bt as useDialog
};
//# sourceMappingURL=dialog.js.map
